// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles-module--grid--2cUzh","wrap":"styles-module--wrap--1b8FJ","slider":"styles-module--slider--e7FRF"};